/*
 * Fetches a catalog type from API and saves it in the vuex store
 * (note: you must first add the catalog type to the
 * vuex catalog module state)
 *
 * Usage: catalogService.fetch('highway')
 *          .then(=> ...)
 *
 * To receive a particular item:
 *
 * catalogService.fetch('highway', 27)
 *
 * catalogService.fetch('highway', {noStore: true})
 */

import Vue from 'vue'
import store from './../../../store'
import catalogTransformers from './../../../transformers/catalog/supplys/supplyHighway'

const save = (catalog, data) => {
  store.dispatch('catalogs/store', data)
}

export default (catalog, opts={}) => {
  let url =  `/purchase/${catalog}/`

  if(typeof(opts) !== "object") {
    opts = {id: opts}
  }
  if (opts.id) {
    url = `${url}${opts.id}/`
    if(opts.extraId){
      url = `${url}/${opts.extraId}/`
    }
  }

  return Vue.$http.get(url, opts.config)
    .then((response) => {
      const transformer = catalogTransformers
      let data = response.data
    if (transformer && transformer.fetch) {
        if (!!opts.id && !opts.collection) {
          data = transformer.fetch(data)
        } else {
          data = transformer.fetchCollection(data)
        }
      }
    if (!opts.id && !opts.noStore) {
        save(catalog, { type: catalog, data })
      }
      return response.data
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/supplyhighway/fetchSupplyHighway.js